import { Star } from "lucide-react";
import useScrollReveal, { useStaggerReveal } from "@/hooks/useScrollReveal";

const TESTIMONIALS = [
  {
    quote:
      "Lograron en seis semanas lo que otros proveedores no pudieron entregar en un año. Equipo brutalmente eficiente.",
    author: "Mariana Salinas",
    role: "Directora de Operaciones · Retail LATAM",
  },
  {
    quote:
      "Su capacidad para integrar IA en flujos reales nos permitió reducir 40% de tareas manuales en el primer trimestre.",
    author: "Carlos Méndez",
    role: "CTO · Fintech B2B",
  },
  {
    quote:
      "Más que proveedores, son socios estratégicos. La calidad del código y la documentación es excepcional.",
    author: "Andrea Vargas",
    role: "VP de Tecnología · Logística",
  },
];

const CLIENT_LOGOS = [
  "AXION",
  "VERTEX",
  "NORDIA",
  "PULSAR",
  "ATLAS DATA",
  "QUANTUM",
  "FIBER OPS",
  "ORBIT TECH",
];

export default function Cases() {
  const headerRef = useScrollReveal();
  const marqueeRef = useScrollReveal();
  const gridRef = useStaggerReveal({ delayStep: 110 });
  return (
    <section
      id="casos"
      data-testid="cases-section"
      className="bg-[#FAFAFA] border-t border-[#E5E5E5]"
    >
      <div className="px-6 md:px-12 lg:px-16 max-w-[1440px] mx-auto py-24 md:py-32">
        <div ref={headerRef} className="reveal-on-scroll grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-7">
            <span className="eyebrow">[ 04 ] Casos de éxito</span>
            <h2 className="display-2 mt-5">
              Clientes que confían en nosotros.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 flex items-end">
            <p className="text-[#525252] text-base md:text-lg leading-relaxed">
              Hemos sido el aliado estratégico en la transformación digital de
              corporativos, PyMEs y startups en LATAM.
            </p>
          </div>
        </div>

        {/* Logo marquee */}
        <div ref={marqueeRef} className="reveal-on-scroll overflow-hidden border-t border-b border-[#E5E5E5] py-10 mb-20">
          <div className="marquee-track">
            {[...CLIENT_LOGOS, ...CLIENT_LOGOS].map((name, i) => (
              <span
                key={i}
                className="font-display text-3xl md:text-4xl font-black tracking-tight text-[#A3A3A3] hover:text-[#171717] transition-colors whitespace-nowrap"
                data-testid={`client-logo-${i}`}
              >
                {name}
              </span>
            ))}
          </div>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, idx) => (
            <figure
              key={t.author}
              data-testid={`testimonial-${idx}`}
              data-stagger-item
              className="swiss-card p-8 md:p-10 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-6 text-[#0047FF]">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} size={14} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              <blockquote className="font-display text-xl md:text-[22px] font-semibold leading-snug tracking-tight text-[#171717] mb-8">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-6 border-t border-[#E5E5E5]">
                <div className="font-bold text-[#171717]">{t.author}</div>
                <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#525252] mt-1">
                  {t.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
